import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import loginImage from "../../../assets/images/login-image.jpg";
import Image from "../../atoms/Image/Image";
import ChangePasswordForm from "../../molecules/Form/ChangePasswordForm";
const ChangePassword = () => {
  return (
    <>
      <section className="login-form section-padding">
        <Container>
          <Row className="g-0 align-items-center justify-content-center">
            <Col className="col-12 col-md-10 p-0 login-form--item">
              <Row className="g-0 align-items-center justify-content-center">
                <Col className="col-12 col-lg-6">
                  <div className="login-form--item-left">
                    <h1 className="h1">Change Password</h1>
                    {/* <p className="mb-0">
                      Your password will be shared with you on your registered
                      email.
                    </p> */}
                    <ChangePasswordForm />
                  </div>
                </Col>
                <Col className="col-12 col-lg-6">
                  <figure className="mb-0 login-form--item--image">
                    <Image src={loginImage} alt="" height="1000" width="900" />
                  </figure>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ChangePassword;
